module.exports = __webpack_public_path__ + "b7104b1d0c751e02e4fe3a137146d1ab.png";